import { SessionContext } from '@contexts/session-context';
import * as Sentry from '@sentry/react';
import { useContext, useEffect } from 'react';

const InitSentry = () => {
  const { session } = useContext(SessionContext);
  const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT;

  useEffect(() => {
    // Initialize Sentry
    //@ts-ignore
    if (!window.__SENTRY__) {
Sentry.init({
        environment: environment,
        dsn: 'https://a56febf791bb931c93b840b67750beaa@o4507154355453952.ingest.us.sentry.io/4507154396676096',
        integrations: [Sentry.browserTracingIntegration(), Sentry.metrics.metricsAggregatorIntegration()],
        // Performance Monitoring
        // added devtesting for testing, need to remove it
        tracePropagationTargets: [],
        allowUrls: [],
        // Capture 20% of the transactions
        tracesSampleRate: 0.2,
      });
    }
  }, []);

  useEffect(() => {
    Sentry.setUser({ email: session?.user?.email, id: session?.user?.id });
    Sentry.setContext('extraData', {
      tenantId: session?.tenant?.id,
      identityServiceUUId: session?.user?.identityUserAccountUUId,
    });
  }, [session?.user?.email, session?.tenant?.id]);

  return <></>;
};

export default InitSentry;
